import { Component, OnInit, Input } from '@angular/core';


@Component({
  selector: 'lib-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  @Input() status: string|undefined;
  @Input() text: string | undefined | null;
  @Input() desc: string | undefined;
  @Input() glyph: string | undefined;
  @Input() size: string | undefined;
  @Input() class: string | undefined;
  @Input() alert: string | undefined;
  @Input() glyphClass: string | undefined;
  @Input() spinnerPosition: boolean = false;
  constructor(
  ) { }

  ngOnInit() {
  }

}
